import FileBrowserCommand from '../../file-browser/src/file-browser-command';

export default class MediaBrowserCommand extends FileBrowserCommand {
	/** Configuration setting name. */
	get configName() { return 'mediaBrowser'; }

	/**
	 * Insert the videos(s).
	 *
	 * @param {string[]} result
	 * @returns
	 */
	insertFile( result ) {
		if ( !result ) {
			return;
		}

		const editor = this.editor;
		editor.execute( 'delete' );
		for ( const source of result ) {
			editor.execute( 'mediaBrowserVideo', source );
		}
	}
}
